import { environment } from '../../environments';

export const register = (language: string) => {
  window.location.assign(`${environment.accountUrl}/${language}/register`);
};

export const getRegisterUrl = (language: string) =>
  `${environment.accountUrl}/${language}/register`;
